import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const RED = '#CC2200';
export function Timer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 21,
    minutes: 44,
    seconds: 18
  });
  useEffect(() => {
    const t = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(t);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const numStyle: React.CSSProperties = {
    color: RED,
    fontFeatureSettings: '"tnum"',
    fontVariantNumeric: 'tabular-nums'
  };
  return <div className="w-full flex justify-center px-4" data-id="element-299">
      <div className="w-full max-w-xl rounded-3xl px-6 sm:px-10 py-10 sm:py-12 flex flex-col items-center text-center" style={{
      background: '#2A0A0A',
      border: '1px solid rgba(204, 34, 0, 0.18)',
      boxShadow: '0 20px 50px -25px rgba(0,0,0,0.7)'
    }} data-id="element-300">
        {/* Title */}
        <p className="text-brand-cream text-[13px] sm:text-base font-extrabold uppercase tracking-[0.16em] mb-8 leading-snug" data-id="element-301">
          ⏰ Precio de lanzamiento — cierra en:
        </p>

        {/* Counter */}
        <div className="flex items-start justify-center gap-1 sm:gap-1.5 mb-2 select-none font-display" data-id="element-302">
          <div className="flex flex-col items-center" data-id="element-303">
            <span className="text-[64px] sm:text-[92px] font-black leading-[0.9] tracking-tighter" style={numStyle} data-id="element-304">
              {fmt(timeLeft.hours)}
            </span>
            <span className="text-[10px] sm:text-xs font-semibold text-brand-cream/55 uppercase tracking-[0.25em] mt-3" data-id="element-305">
              HS
            </span>
          </div>
          <span className="text-[52px] sm:text-[78px] font-black leading-[0.9] -mt-0.5" style={numStyle} data-id="element-306">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-307">
            <span className="text-[64px] sm:text-[92px] font-black leading-[0.9] tracking-tighter" style={numStyle} data-id="element-308">
              {fmt(timeLeft.minutes)}
            </span>
            <span className="text-[10px] sm:text-xs font-semibold text-brand-cream/55 uppercase tracking-[0.25em] mt-3" data-id="element-309">
              MIN
            </span>
          </div>
          <span className="text-[52px] sm:text-[78px] font-black leading-[0.9] -mt-0.5" style={numStyle} data-id="element-310">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-311">
            <span className="text-[64px] sm:text-[92px] font-black leading-[0.9] tracking-tighter" style={numStyle} data-id="element-312">
              {fmt(timeLeft.seconds)}
            </span>
            <span className="text-[10px] sm:text-xs font-semibold text-brand-cream/55 uppercase tracking-[0.25em] mt-3" data-id="element-313">
              SEG
            </span>
          </div>
        </div>

        {/* Alert */}
        <p className="text-brand-cream font-bold text-sm sm:text-base mt-8 mb-8" data-id="element-314">
          ⚠️ Después sube{' '}
          <span style={{
          color: RED
        }} className="font-extrabold" data-id="element-315">
            $8.000 ARS
          </span>
          . No vuelve.
        </p>

        {/* Progress bar */}
        <div className="w-full max-w-md" data-id="element-316">
          <div className="flex items-center justify-between mb-2.5 text-[11px] sm:text-[13px] font-bold" data-id="element-317">
            <span className="text-brand-cream/85 flex items-center gap-1.5" data-id="element-318">
              <span className="inline-block w-2 h-2 rounded-full" style={{
              background: RED
            }} data-id="element-319"></span>
              Cupos al precio de lanzamiento
            </span>
            <span style={{
            color: RED
          }} data-id="element-320">
              Quedan pocos
            </span>
          </div>
          <div className="h-2.5 w-full rounded-full overflow-hidden" style={{
          background: 'rgba(0,0,0,0.45)'
        }} data-id="element-321">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.2,
            ease: 'easeOut'
          }} className="h-full rounded-full" style={{
            background: RED
          }} data-id="element-322" />
          </div>
          <p className="mt-3 text-brand-cream/55 text-[11px] sm:text-[13px] font-medium" data-id="element-323">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
}